import { Money, TransactionType } from 'types';
import { toDisplayDateFormat } from 'lib/utils/date';
import { CreditCardPaymentMethodFieldsFragment } from 'lib/graphql';
import LineItem from 'components/LineItem';

export interface CashLineItemProps extends Pick<CreditCardPaymentMethodFieldsFragment, 'cardType'> {
  type: TransactionType;
  createdAt: string | Date;
  cardNumber: string;
  total: Money;
}

const CashLineItem = ({ type, createdAt, cardType, cardNumber, total }: CashLineItemProps) => (
  <LineItem title="Credit card" totals={[total]}>
    {type === 'REFUND'
      ? `Refunded on ${toDisplayDateFormat(createdAt)} to ${cardType} ending ${cardNumber}`
      : `Paid on ${toDisplayDateFormat(createdAt)} using ${cardType} ending ${cardNumber}`}
  </LineItem>
);

export default CashLineItem;
